<template>

    <div>
        <span class="alarmeJeMonat" v-if="chartdata">
           <line-chart
                   v-if="loaded"
                   :chartdata="chartdata"
                   :options="options"
           />
        </span>
        <div v-else-if="!chartdata && !loaded" class="text-center">
            <SpinnerImage />
        </div>
    </div>

</template>

<script>

    import axios from 'axios'
    axios.defaults.withCredentials = true
    import LineChart from '@/components/charts/LineChart'
    import SpinnerImage from "@/components/layout/SpinnerImage"

    export default {
      name: 'LineStackedAreaChartAlarmeNachMonaten',
      components: {
        LineChart,
        SpinnerImage,
      },
      props: ['besuchsbericht', 'filter', 'traplinkedbericht'],
      data () {
        return {
          cancelTokenSource: null,
          loaded: false,
          /** Daten für den Chart */
          chartdata: null,
          options:
            {
              responsive: true,
              maintainAspectRatio: false,
              hover: {
                mode: 'index'
              },
              plugins: {
                title: {
                  display: true,
                  text: this.$t('message.charts_relative')
                },
                legend: {
                  display: false
                },
                tooltip: {
                  callbacks: {
                    label: function (ctx) {
                      var label = ctx.dataset.label || ''
                      if (label) {
                        label += ': ' + ctx.parsed.y
                      }
                      return label + ' %'
                    }
                  }
                }
              },
              scales: {
                x: {
                  title: {
                    display: true
                  }
                },
                y: {
                  beginAtZero: true,
                  stacked: true,
                  title: {
                    display: true
                  },
                  ticks: {
                    callback: function (value) { if (Number.isInteger(value)) { return value + '%'; } },
                    stepSize: 10
                  }
                }
              }
            },
            /** Filter der Charts */
            filterung: {
              /** Filter nach einer Objektkategorie */
              filterObjektkategorie: null,
              /** Filter nach einer Area */
              filterArea: null,
            }
        }
      },
      watch: {
        besuchsbericht: function () {
            this.init()
        },
        traplinkedbericht: function () {
            this.init()
        },
        filter: {
          handler: function (newObj) {
            // do stuff
            this.filterung = newObj
            this.init()
          },
          deep: true
        }
      },
      created () {
        this.init()
      },
      methods: {

        init: async function () {

          // vorherigen Request abbrechen falls noch laufend
          if (this.cancelTokenSource) {
            this.cancelTokenSource.cancel()
          }
          this.cancelTokenSource = axios.CancelToken.source()

          this.loaded    = false
          this.chartdata = null
          if (this.besuchsbericht || this.traplinkedbericht) {

            // ich brauche hier die Areas von allen Standorten des Benutzers:
            let areasAllowed = null
            if (this.$store.getters.showAreas && this.$store.getters.showAreas.length > 0) {
              areasAllowed = this.$store.getters.showAreas.join(',')
            }

            const url     = process.env.VUE_APP_SERVER_URL + '/datenbroker/getChartDataOfBesuchsbericht'
            const params  = {
              besuchsbericht_id:        this.besuchsbericht ? this.besuchsbericht.id : null,
              traplinkedbericht_id:     this.traplinkedbericht ? this.traplinkedbericht.id : null,
              type:                     'LINE_STACKED_AREA_CHART_ALARME_NACH_MONATEN',
              filterObjektkategorie:    this.filterung ? this.filterung.filterObjektkategorie : null,
              filterArea:               this.filterung ? this.filterung.filterArea : null,
              areasAllowed:             areasAllowed,
              auftragsart:              this.filterung ? JSON.stringify(this.filterung.auftragsart) : null,
            }

            const that = this
            await axios({
              method: 'GET',
              params: params,
              url: url,
              cancelToken: this.cancelTokenSource.token
            }).then(function (response) {

              if (response.data) {

                that.chartdata = response.data.chartdata
                if (that.chartdata) {

                  var datasets = that.chartdata.datasets
                  if (datasets) {
                    // Chart.js 4: fill und tension auf Datasets setzen (Defaults
                    // in 3+ sind fill:false und tension:0)
                    datasets.forEach(ds => {
                      ds.fill = true
                      ds.tension = 0.4
                    })
                    console.info('datasets', datasets)
                  } else {
                    that.chartdata = null
                    that.$emit('set-no-data', true)
                  }

                } else { // end if that.chartdata
                  that.$emit('set-no-data', true)
                }

              }
              that.loaded = true

            }).catch(error => {
              if (axios.isCancel(error)) return
              console.log(error)
              that.loaded = true
              that.$emit('set-no-data', true)
            })
          }

        }

      }

    }

</script>
